import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { BehaviorSubject, Observable, merge, of } from 'rxjs';
import { delay, map, switchMap, tap } from 'rxjs/operators';
import { FormInputComponent, IFormInputViewModel } from 'src/app/share/forms/form-input/form-input.component';
import { FormSelectComponent, IDisplaySelectViewModel, IFormSelectChangedArg, IFormSelectViewModel } from 'src/app/share/forms/form-select/form-select.component';
import { IPageContentFormViewModel, IPageContentViewModel, IPageDataViewModel, IPageViewModel } from 'src/app/share/pages/pages';
import { AuthService } from 'src/app/share/services/auth.service';
import { CommonService } from 'src/app/share/services/common.service';
import { IOption } from 'ng-uikit-pro-standard';
import { BasePageComponent, IBasePageOnInitArg } from 'src/app/share/pages/base-page.component';
import { ShellService } from 'src/app/shell/shell.service';
import { ActivatedRoute } from '@angular/router';
import { IDataPanelViewModel, IRowViewModel, IViewData } from 'src/app/share/entities/view-model';
import { formatDate } from '@angular/common';
import { IDataTableRowActionClickArg } from 'src/app/share/components/data-table-card/data-table-card.component';
import { FormOkCancelComponent, IFormOkCancelViewModel } from 'src/app/share/forms/form-ok-cancel/form-ok-cancel.component';
import {saveAs} from "file-saver";


@Component({
  selector: 'app-vendor-payout',
  templateUrl: './vendor-payout.component.html',
  styleUrls: ['./vendor-payout.component.scss']
})
export class VendorPayoutComponent extends BasePageComponent implements OnInit {

  private readonly apiPath: string = '/api/accounting';

  constructor(private commonService: CommonService, private authService: AuthService, protected shellService: ShellService, protected activatedRate: ActivatedRoute) {
    super(shellService, activatedRate);
  }

  searchData: string = '';
  canAddNew: boolean = false;
  invalidRecords: boolean = false;
  nonActiveRecords: boolean = false;

  /**
   *
   * @param action
   * @param paramData
   * @returns
   */
  private commandInvoke(action: string, paramData): Observable<IPageDataViewModel> {
    return this.commonService.getData('PageCommand', 'vendor-payout', action, paramData, this.apiPath, true);
  }

  /**
   *
   * @param pvm
   * @param vm
   */
  onPageAddNew(pvm: IPageViewModel, vm: IContentViewModel) {
    if (this.canAddNew)
      this.vendorFormStart(undefined, pvm, 'new');
  }

  /**
   *
   * @param pvm
   * @param vm
   */
  private async vendorFormStart(data: IVendorInfoModel, pvm: IPageViewModel, action: string) {
    const fvm = super.formBegin(pvm, this.vendorInfo(data, action));

    await super.formLoadAsync(fvm, () => {
      return of({}).pipe(
        delay(500) /* todo... implement work */
      );
    });
  }

  /**
   *
   * @param vm
   * @returns
   */
  private vendorInfo(d: IVendorInfoModel, action: string): IFormViewModel {

    const data = {
      vendorNumber: !d || action == 'new' ? '' : d.vendorNumber,
      vendorCode: !d || action == 'new' ? '' : d.driverNumber,
      paymentMethodCode: !d || action == 'new' ? '' : d.paymentMethod,
      addressCode: !d || action == 'new' ? '' : d.addressCode,
      billingCycle: !d || action == 'new' ? '' : d.billingCycle,
      comments: !d || action == 'new' ? '' : d.comments,
      originalComments: !d || action == 'new' ? '' : d.comments,
      action: action,
      user: this.authService.userName()
    };

    const ret: IFormViewModel = {
      ...super.formVm('handle-upload', { okCancelOptions: {} }),

      title: action == 'delete'
        ? 'Vendor Info Delete Confirmation'
        : action == 'new'
          ? 'New Vendor Info Input'
          : 'Edit Vendor Info',
      data: data,

      isValid: action == 'delete' ? true : false,

      message: action != 'delete' ? '' : `Are you sure you want to delete vendor ${data.vendorNumber}`,

      vendorNumberInputVm: FormInputComponent.viewModel(data, 'vendorNumber', { title: 'Vendor Number', type: 'text', isRequired: true, isLocked: action == 'new' ? false : true }),
      vendorCodeInputVm: FormInputComponent.viewModel(data, 'vendorCode', { title: 'Vendor Code', type: 'text', isRequired: true, isLocked: false }),
      paymentMethodCodeInputVm: FormSelectComponent.viewModel(data, 'paymentMethodCode',
                { title: 'Payment Method', isRequired: true, type: 'select', isLocked: false }, this.setPaymentMethod()),
      addressCodeInputVm: FormInputComponent.viewModel(data, 'addressCode', { title: 'Address Code', type: 'text', isRequired: true, isLocked: false }),
      billingCycleInputVm: FormSelectComponent.viewModel(data, 'billingCycle',
            { title: 'Billing Cycle', isRequired: true, type: 'select', isLocked: false }, this.setBillingCycle()),
      commentsInputVm: FormInputComponent.viewModel(data, 'comments', { title: 'Comments', type: 'text', isRequired: false, isLocked: false }),
    };
    return ret;
  }

  /**
   *
   * @param pvm
   * @param vm
   * @param fvm
   */
  async vendorInfoFormOk(pvm: IPageViewModel, vm: IContentViewModel, fvm: IFormViewModel) {
    const success = await FormOkCancelComponent.processOkAsync(fvm.okCancelVm, 'Saving...',
      () => this.commandInvoke('vendor-info-save', fvm.data));

    if (success)
      this.formEndRefresh(pvm);
  }

  ngOnInit(): void {

    super.onInit((arg: IBasePageOnInitArg) => {

      // user page
      return of({}).pipe(

        // load content VM
        switchMap(() => this.commandInvoke('page-load', {})),

        // return page VM
        map((d: IPageDataViewModel) => {
          console.log('ngOnInit()', d);
          if (d.workingText || d.errorText)
            return d;

          const ret: IPageDataViewModel = {
            ...d,

            contentVm: this.contentViewModel(arg, d.data)
          };
          return ret;
        })
      );
    }, { canRefresh: true, canAddNew: true, canGoBack: true });
  }

  private contentViewModel(arg: IBasePageOnInitArg, data: IDataModel): IContentViewModel {
    // view model

    var dataModel = { vendorType: [] };
    const vm: IContentViewModel = {
      dataVm: {
        payoutTabVm: {
          filterVm: this.setFilterData(data),
          showResultForm: false,
          fileLoadFormVm: undefined,
          disableSubmitButton: false,
          showDataChangeMessage: false
        },
        vendorInfoTabVm: {
          data: { vendorInfo: data.vendorInfo },
          //vendorType: [],
          vendorInfosVm: data.vendorInfo ? {
            data: {
              columns: [ "Vendor Number", "Vendor Name", "Type", "Driver Number", "Payment Method", "Address Code", "Billing Cycle", "Is Active", "Comments" ],
              unauthorized: false,
              rows: data.vendorInfo.map(r => [ r.vendorNumber, r.vendorName, r.type, r.driverNumber, r.paymentMethod, r.addressCode, r.billingCycle, r.isActive ? 'Yes' : 'No', r.comments ]),
            },
            rows: this.loadVendorInfo(data.vendorInfo, 'true'),
            rowsFiltered: this.loadVendorInfo(data.vendorInfo, 'true'),
            styleTypes: [],
            styleTypesFiltered: undefined,
            showActionColumn: true
          } : null,
          filterVm: this.setFilterData2(data)
        }
      }
    };
    console.log('contentViewModel', vm);
    return vm;
  }

  loadVendorInfo(data: IVendorInfoModel[], includeActiveOnly: string): IRowViewModel[] {
    var ret: IRowViewModel[] = [];

    data.forEach(r => {
      var goodRec: boolean = false;
      if (includeActiveOnly == 'true' && r.isActive == true) {
        goodRec = true;
      }
      else if (includeActiveOnly == 'false' && r.isActive != true) {
        goodRec = true;
      }
      else if (includeActiveOnly == 'both') {
        goodRec = true;
      }
      if (goodRec) {
        ret.push({
          code: r.vendorNumber,
          fields: [ r.vendorNumber, r.vendorName, r.type, r.driverNumber, r.paymentMethod, r.addressCode, r.billingCycle, r.isActive ? 'Yes' : 'No', r.comments ],
          actions: [ { code: 'edit', name: 'Edit' }, { code: 'delete', name: 'Delete' } ]
        });
      }
    });
    return ret;
  }

  /**
   *
   * @param dm
   * @returns
   */
  setFilterData(dm: IDataModel): IFilterViewModel {

    const data: IFilterData = { fromDate: '', toDate: '', reportType: '' };
    return {
      data: data,
      showInputRow: false,
      reportTypeVm: FormSelectComponent.viewModel(data, 'reportType',
                { title: 'Report Type', isRequired: false, type: 'select' }, this.setReportType()),
      fromDateInputVm: FormInputComponent.viewModel(data, 'fromDate',
                { title: 'From Date', isRequired: false, type: 'date', isLocked: true }),
      toDateInputVm: FormInputComponent.viewModel(data, 'toDate',
                { title: 'To Date', isRequired: false, type: 'date', isLocked: true }),
      vendorTypeVm: FormSelectComponent.viewModel(data, 'vendorType',
                { title: 'Vendor Type', isRequired: false, type: 'select', isLocked: true }, this.setVendorType(dm.vendorPayouts.vendorTypes)),
      billingCycleVm: FormSelectComponent.viewModel(data, 'billingCycle',
                { title: 'Billing Cycle', isRequired: false, type: 'select', isLocked: true }, this.setBillingCycle()),
      paymentTypeVm: FormSelectComponent.viewModel(data, 'paymentMethodCode',
                { title: 'Payment Method', isRequired: false, type: 'select', isLocked: true }, this.setPaymentMethod()),
    };
  }

  /**
   *
   * @param dm
   * @returns
   */
  setFilterData2(dm: IDataModel): IFilterViewModel {

    const data: IFilterData = { fromDate: '', toDate: '', reportType: '' };
    return {
      data: data,
      showInputRow: false,
      vendorTypeVm: FormSelectComponent.viewModel(data, 'vendorType',
                { title: 'Vendor Type', isRequired: false, type: 'select', isLocked: false }, this.setVendorType(dm.vendorPayouts.vendorTypes))
    };
  }

  /**
   *
   * @param vm
   * @param fvm
   */
  requestInputValidate(vm: IPayoutViewModel, checkPaymentMethod: boolean) {
    vm.isValid =
      (vm.filterVm?.data?.fromDate ?? '').length == 10
      && (vm.filterVm?.data?.toDate ?? '').length == 10
      && (vm.filterVm?.data?.reportType ?? '').length > 0
      && (vm.filterVm?.data?.vendorType ?? []).length > 0
      //&& (vm.filterVm?.data?.billingCycle ?? []).length > 0

    //if (vm.isValid && checkPaymentMethod && (vm.filterVm?.data?.paymentMethodCode ?? '').length == 0)
    //  vm.isValid = false;

    this.setPayoutFormData(vm);
  }

  /**
   *
   * @param vm
   * @param fvm
   */
  requestFormValidate(vm: IContentViewModel, fvm: IFormViewModel) {
    const valids = [
      !fvm.data.vendorNumber ? false : true,
      !fvm.data.vendorCode ? false : true,
      !fvm.data.paymentMethodCode ? false : true,
      !fvm.data.addressCode ? false : true,
      !fvm.data.billingCycle ? false : true
    ];
    fvm.isValid = valids.filter(v => !v).length == 0 || fvm.data.comments != fvm.data.originalComments;
  }

  setReportType(): IDisplaySelectViewModel {
    var options: IOption[] = [
      //{ value: 'concur-import-preview', label: 'Generate file for Concur import (check)', icon: '' },
      { value: 'dynamic-import-preview', label: 'Generate file for Dynamic import only', icon: '' },
      //{ value: 'concur-dynamic', label: 'Convert Concur file for Dynamic import', icon: '' }
    ];

    // if (this.authService.userName() == 'ymk') {
    //   options.push({ value: 'concur-import-file', label: 'TEST: Generate encrypted file for Concur', icon: '' });
    //   options.push({ value: 'concur-import-file-submit', label: 'TEST: Generate encrypted file for Concur and submit', icon: '' });
    //   options.push({ value: 'concur-import-orig-file', label: 'TEST: Generate original file for Concur', icon: '' });
    // }

    const ret: IDisplaySelectViewModel = {
      description: 'Please select report type...',
      options: options,
      multiple: false
    };
    return ret;
  }

  setPaymentMethod(): IDisplaySelectViewModel {
    var options: IOption[] = [
      { value: 'wire', label: 'Wire', icon: '' },
      { value: 'check', label: 'Check', icon: '' },
      { value: 'cc', label: 'Credit Card', icon: '' },
      { value: 'ach', label: 'ACH', icon: '' }
    ];

    const ret: IDisplaySelectViewModel = {
      description: 'Please select payment method...',
      options: options,
      multiple: false
    };
    return ret;
  }

  reportTypeChanged(e: IFormSelectChangedArg, vm: IPayoutViewModel, vmc: IContentViewModel) {
    vm.fileLoadFormVm = undefined;
    vm.showResultForm = false;
    vm.payoutResultPreviewVm = undefined;
    vm.isReadyForProcess = false;
    vm.showDataChangeMessage = false;
    vm.showPaymentMethodOption = false;

    if (e.option.value == 'dynamic-import-preview')
      vm.showPaymentMethodOption = true;

    if (e.option.value == 'concur-dynamic') {
      vm.filterVm.fromDateInputVm.isLocked = true;
      vm.filterVm.toDateInputVm.isLocked = true;
      vm.filterVm.vendorTypeVm.isLocked = true;
      vm.filterVm.billingCycleVm.isLocked = true;
      vm.filterVm.paymentTypeVm.isLocked = true;
      vm.isValid = false;
      vm.filterVm.showInputRow = false;
      this.fileFormLoadStart(vm);
    } else {
      vm.filterVm.fromDateInputVm.isLocked = false;
      vm.filterVm.toDateInputVm.isLocked = false;
      vm.filterVm.vendorTypeVm.isLocked = false;
      vm.filterVm.billingCycleVm.isLocked = false;
      vm.filterVm.paymentTypeVm.isLocked = false;
      vm.filterVm.showInputRow = true;
      vm.warningMessage = this.buildWarningMessage(vmc);
    }
    this.requestInputValidate(vm, vm.showPaymentMethodOption ? true : false);
  }

  buildWarningMessage(vmc: IContentViewModel): string {

    var errorCount: number = 0;
    (vmc.dataVm?.vendorInfoTabVm?.vendorInfosVm?.rows ?? []).forEach((r, i) => {
      r.fields.forEach((c, i) => {
        if ((i == 3 || i == 4 || i == 5) && ((c ?? '').length == 0 || (c ?? '') == 'unknown')) {
          errorCount++;
        }
      });
    });

    return errorCount > 0 ? `${errorCount} errors found in Vendor Information tab. Please fix the errors before proceeding.` : '';
  }

  setVendorType(data: IVendorTypeDataModel): IDisplaySelectViewModel {
    var options: IOption[] = data.options.map(o => {
      const ret: IOption = {
        value: o.value,
        label: o.label,
        icon: o.icon ?? '',
        type: o.type ?? ''
      };
      return ret;
    });

    const ret: IDisplaySelectViewModel = {
      description: 'Please select vendor type...',
      options: options,
      multiple: true
    };
    return ret;
  }

  setBillingCycle(): IDisplaySelectViewModel {
    var options: IOption[] = [
      { value: 'daily', label: 'Daily', icon: '' },
      { value: 'weekly', label: 'Weekly', icon: '' },
      { value: 'monthly', label: 'Monthly', icon: '' },
      { value: 'semi-monthly', label: 'SemiMonthly', icon: '' },
      { value: 'bi-weekly', label: 'BiWeekly', icon: '' },
      { value: 'one-time', label: 'OneTime', icon: '' }
    ];

    if (this.authService.userName() == 'ymk')
      options.push({ value: 'all', label: 'All', icon: '' });

    const ret: IDisplaySelectViewModel = {
      description: 'Please select billing cycle...',
      options: options,
      multiple: false
    };
    return ret;
  }

  vendorTypeChanged(e: IFormSelectChangedArg, vm: IPayoutViewModel) {
    this.requestInputValidate(vm, vm.showPaymentMethodOption ? true : false);
  }

  paymentMethodSelectChanged(e: IFormSelectChangedArg, vm: IPayoutViewModel) {
    this.requestInputValidate(vm, vm.showPaymentMethodOption ? true : false);
  }

  vendorInfoTypeChanged(e: IFormSelectChangedArg, vm: IContentViewModel) {
    this.filterData(vm);
  }

  billingCycleChanged(e: IFormSelectChangedArg, vm: IPayoutViewModel) {

    this.requestInputValidate(vm, vm.showPaymentMethodOption ? true : false);
  }

  paymentMethodChanged(e: IFormSelectChangedArg, vm: IContentViewModel, fvm: IFormViewModel) {

    this.requestFormValidate(vm, fvm);
  }

  billingCycleInputChanged(e: IFormSelectChangedArg, vm: IContentViewModel, fvm: IFormViewModel) {

    this.requestFormValidate(vm, fvm);
  }

  /**
   *
   * @param event
   */
  onGetActiveTab(pvm: IContentViewModel, event: any) {
    const title = event?.el?.heading?.length ? event.el.heading : '';


    this.canAddNew = false;
    if (title == 'Vendor Information')
      this.canAddNew = true;
  }

  /**
   *
   * @param pvm
   * @param vm
   * @param tvm
   * @param arg
   */
  rowActionInvoke(arg: IDataTableRowActionClickArg, vm: IContentViewModel, pvm: IPageViewModel) {

    const data = vm.dataVm.vendorInfoTabVm.data.vendorInfo.find(i => i.vendorNumber == arg.rowCode);
    this.vendorFormStart(data, pvm, arg.actionCode);
  }

  rowPreviewActionInvoke(arg: IDataTableRowActionClickArg, vm: IContentViewModel, pvm: IPageViewModel) {

    const data = vm.dataVm.payoutTabVm.payoutResultPreviewVm.vendorPayoutPreviewVm.rows.find(r => r.code == arg.rowCode);

    switch(arg.actionCode) {
      case 'view':
        vm.dataVm.payoutTabVm.payoutResultPreviewVm.vendorPayoutDetailPreviewVm.rowsFiltered = [];
        (vm.dataVm.payoutTabVm.payoutResultPreviewVm.vendorPayoutDetailPreviewVm.rows ?? []).forEach(r => {
          if (r.code == arg.rowCode)
            vm.dataVm.payoutTabVm.payoutResultPreviewVm.vendorPayoutDetailPreviewVm.rowsFiltered.push(r);
        });
        vm.dataVm.payoutTabVm.showPreviewDetailForm = true;
        break;
      case 'ignore-error':
        (vm.dataVm.payoutTabVm.payoutResultPreviewVm.data.payoutData ?? []).forEach(r => {
          if (r.vendorNumber == arg.rowCode)
            r.errorIgnoreFlag = true;
        });
        (vm.dataVm.payoutTabVm.payoutResultPreviewVm.vendorPayoutPreviewVm.rows ?? []).forEach(r => {
          if (r.code == arg.rowCode)
            r.ignore = true;
        });
        (vm.dataVm.payoutTabVm.payoutResultPreviewVm.vendorPayoutPreviewVm.rowsFiltered ?? []).forEach(r => {
          if (r.code == arg.rowCode) {
            r.ignore = true;
            r.actions = r.actions.filter(a => a.code !== 'ignore-error');
          }
        });
        this.setIsReadyForProcessFlag(vm);
        break;
    }
  }

  setIsReadyForProcessFlag(vm: IContentViewModel)
  {
    var isErrorFound: boolean = false;

    (vm.dataVm.payoutTabVm.payoutResultPreviewVm.data.payoutData ?? []).forEach(r => {
      if (r.cannotIgnore && (r.comments ?? '').length > 0) {
        isErrorFound = true;
      }
    });
    if (!isErrorFound) {
      (vm.dataVm.payoutTabVm.payoutResultPreviewVm.vendorPayoutPreviewVm.rows ?? []).forEach(r => {
        var ix = r.fields?.length - 1;
        if (r.fields[ix].length > 0 && !r.ignore) {
          isErrorFound = true;
        }
      });
    }
    vm.dataVm.payoutTabVm.isReadyForProcess = !isErrorFound;
  }

  /**
   *
   * @param vm
   * @param searchVal
   * @returns
   */
  doDataSearch(vm: IContentViewModel, searchVal: string) {

    this.searchData = searchVal;
    if (searchVal.length === 0) {
      vm.dataVm.vendorInfoTabVm.vendorInfosVm.rowsFiltered = vm.dataVm.vendorInfoTabVm.vendorInfosVm.rows;
      return;
    }

    vm.dataVm.vendorInfoTabVm.vendorInfosVm.rowsFiltered = [];
    (vm.dataVm.vendorInfoTabVm.vendorInfosVm.rows ?? []).forEach((r, i) => {
      let notFound: boolean = true;
      (r.fields ?? []).forEach(c => {
        if (notFound && typeof c === "string" && (c ?? '').toLowerCase().indexOf(searchVal.toLowerCase()) > -1) {
          vm.dataVm.vendorInfoTabVm.vendorInfosVm.rowsFiltered.push(r);
          notFound = false;
        }
      });
    });
  }

  nonActiveRecordsChanged(vm: IContentViewModel, event: any) {
    this.filterData(vm);
    // vm.dataVm.vendorInfoTabVm.vendorInfosVm.rowsFiltered =
    //   this.loadVendorInfo(vm.dataVm.vendorInfoTabVm.data.vendorInfo, this.nonActiveRecords ? 'false' : 'true');
  }

  invalidRecordsChanged(vm: IContentViewModel, event: any) {

    this.filterData(vm);
  }

  filterData(vm: IContentViewModel) {

    vm.dataVm.vendorInfoTabVm.workingText = 'Sorting...';

    vm.dataVm.vendorInfoTabVm.vendorInfosVm.rows = this.loadVendorInfo(vm.dataVm.vendorInfoTabVm.data.vendorInfo, this.nonActiveRecords ? 'false' : 'true');
    if (!this.invalidRecords && (vm?.dataVm?.vendorInfoTabVm?.filterVm?.data?.vendorType ?? '').length == 0) {
      vm.dataVm.vendorInfoTabVm.vendorInfosVm.rowsFiltered = this.loadVendorInfo(vm.dataVm.vendorInfoTabVm.data.vendorInfo, this.nonActiveRecords ? 'false' : 'true');
      vm.dataVm.vendorInfoTabVm.workingText = undefined;
      return;
    }

    vm.dataVm.vendorInfoTabVm.vendorInfosVm.rowsFiltered = [];
    vm.dataVm.vendorInfoTabVm.vendorInfosVm.rows.forEach((r, i) => {

      if (this.invalidRecords && (vm?.dataVm?.vendorInfoTabVm?.filterVm?.data?.vendorType ?? '').length > 0) {
        let invMatch: boolean = false;
        let typeMatch: boolean = false;
        r.fields.forEach((c, i) => {
          if ((i == 2 || i == 3 || i == 4 || i == 5 || i == 6) && ((c ?? '').length == 0 || (c ?? '') == 'unknown')) {
            invMatch = true;
          }
        });
        (vm?.dataVm?.vendorInfoTabVm?.filterVm.data.vendorType ?? []).forEach(f => {
          if (f == r.fields[2])
            typeMatch = true;
        });
        if (invMatch && typeMatch)
          vm.dataVm.vendorInfoTabVm.vendorInfosVm.rowsFiltered.push(r);
      }
      else if (this.invalidRecords) {
        let invMatch: boolean = false;
        r.fields.forEach((c, i) => {
          if ((i == 3 || i == 4 || i == 5) && ((c ?? '').length == 0 || (c ?? '') == 'unknown')) {
            invMatch = true;
          }
        });
        if (invMatch)
          vm.dataVm.vendorInfoTabVm.vendorInfosVm.rowsFiltered.push(r);
      }
      else {
        let typeMatch: boolean = false;
        (vm?.dataVm?.vendorInfoTabVm?.filterVm.data.vendorType ?? []).forEach(f => {
          if (f == r.fields[2])
            typeMatch = true;;
        });
        if (typeMatch)
            vm.dataVm.vendorInfoTabVm.vendorInfosVm.rowsFiltered.push(r);
      }
    });
    vm.dataVm.vendorInfoTabVm.workingText = undefined;
  }

  /**
   *
   * @param vm
   */
  payoutDetailLoadEnd(vm: IPayoutViewModel) {
    vm.payoutResultPreviewVm = undefined;
    vm.showResultForm = false;
    vm.disableSubmitButton = false;
  }

  closeButtonClicked(vm: IPayoutViewModel) {
    vm.showPreviewDetailForm = false;
    vm.payoutResultPreviewVm.vendorPayoutDetailPreviewVm.rowsFiltered = vm.payoutResultPreviewVm.vendorPayoutDetailPreviewVm.rows;
  }

  async processButtonClicked(vm: IPayoutViewModel) {
    vm.workingText = 'Submiting the payout records... please wait';
    vm.showDataChangeMessage = false;
    vm.payoutResultPreviewVm.vendorPayoutPreviewVm = undefined;
    vm.payoutResultPreviewVm.vendorPayoutDetailPreviewVm = undefined;
    vm.payoutResultPreviewVm.okCancelVm = undefined;

    const ret = await of({}).pipe(
      delay(100),
      switchMap(() => this.commonService.getData('PageCommand', 'vendor-payout', 'concur-import',
              { fromDate: vm.filterVm.data.fromDate, toDate: vm.filterVm.data.toDate, vendorTypes: vm.filterVm.data.vendorType,
                billingCycle: vm.filterVm.data.billingCycle, user: this.authService.userName(), reportType: vm.filterVm.data.reportType,
                data: vm.payoutResultPreviewVm.data.payoutData, paymentMethodCode: vm.filterVm.data.paymentMethodCode }, this.apiPath)),
      map(ctx => ctx ?? undefined)
    ).toPromise();

    if (ret?.data) {
      vm.payoutResultPreviewVm = undefined;
      vm.workingText = undefined;
      vm.disableSubmitButton = false;
      if (ret.data.status == 2 && ret.data.outputType == 'file') {
        vm.workingText = ret.data.message;

        (ret.data.outputFiles ?? []).forEach(f => {
          if (f.fileContentType == 'application/octet-stream') {
            const data: Blob = new Blob([f.fileContentBinary], {
              type: f.fileContentType
            });
            saveAs(data, f.fileName);
          } else {
            const data: Blob = new Blob([f.fileContent], {
              type: f.fileContentType
            });
            saveAs(data, f.fileName);
          }
        });

      } else {
        if (ret.data.status == 3 && (ret.data.errorText ?? '').length > 0) {
          vm.workingText = undefined;
          vm.errorText = ret.data.errorText;
        }
        switch(ret.data.messageType) {
          case 1: vm.showDataChangeMessage = true; break;
        }
      }
    }
  }s

  async buttonClicked(vm: IPayoutViewModel) {

    try {
      this.setPayoutFormData(vm);
      vm.showResultForm = true;
      vm.payoutResultPreviewVm = undefined;
      vm.workingText = 'Generating the payout records... please wait';
      vm.showSpinner = true;
      vm.showDataChangeMessage = false;

      const ret = await of({}).pipe(
        delay(100),
        switchMap(() => this.commonService.getData('PageCommand', 'vendor-payout', vm.filterVm.data.reportType,
                { fromDate: vm.filterVm.data.fromDate, toDate: vm.filterVm.data.toDate, vendorTypes: vm.filterVm.data.vendorType,
                  billingCycle: vm.filterVm.data.billingCycle, paymentMethodCode: vm.filterVm.data.paymentMethodCode,
                  user: this.authService.userName() }, this.apiPath)),
        map(ctx => ctx ?? undefined)
      ).toPromise();

      vm.disableSubmitButton = false;
      vm.showSpinner = false;
      vm.errorText = undefined;
      vm.showPreviewDetailForm = false;
      if (ret.data) {

        if (ret.data.status == 2 && ret.data.outputType == 'file-download') {
          vm.workingText = ret.data.message;
          const data: Blob = new Blob([ret.data.content], {
            type: ret.data.contentType
          });
          saveAs(data, ret.data.fileName);
        }
        else if (ret.data.status == 2) {
          vm.disableSubmitButton = true;
          vm.workingText = undefined;
          vm.payoutResultPreviewVm = {
            data: { payoutData: ret.data.payoutData, vendorPayoutDetailPreview: ret.data.vendorPayoutDetailPreview },
            vendorPayoutPreviewVm: ret.data.payoutData && !ret.data.payoutData.unauthorized ? {
              data: {
                columns: [ "Vendor Number", "Vendor Name", "Driver Number", "Type", "Payment Method", "Address Code", "BillingCycle", "Payout Amount", "Comments" ],
                unauthorized: ret.data.payoutData.unauthorized,
                rows: ret.data.payoutData.map(r => [ r.vendorNumber, r.vendorName, r.driverNumber, r.type, r.paymentMethod, r.addressCode, r.billingCycle, r.payoutAmountString, r.comments ]),
              },
              rows: ret.data.payoutData.map(r => {
                const row: IRowViewModel = {
                  code: r.vendorNumber,
                  ignore: r.errorIgnoreFlag,
                  fields: [ r.vendorNumber, r.vendorName, r.driverNumber, r.type, r.paymentMethod, r.addressCode, r.billingCycle, r.payoutAmountString, r.comments ],
                  actions: [ { code: 'view', name: 'View' } ]
                }
                return row;
              }),
              rowsFiltered: ret.data.payoutData.map(r => {
                const row: IRowViewModel = {
                  code: r.vendorNumber,
                  ignore: r.errorIgnoreFlag,
                  fields: [ r.vendorNumber, r.vendorName, r.driverNumber, r.type, r.paymentMethod, r.addressCode, r.billingCycle, r.payoutAmountString, r.comments ],
                  actions: [ { code: 'view', name: 'View' } ]
                }
                return row;
              }),
              styleTypes: [],
              styleTypesFiltered: [],
              //lastUpdateDateTime: formatDate(ret.data.vendorPayoutPreview.lastUpdateDateTime, 'MM/dd/yyyy HH:mm:ss', 'en-US'),
              showActionColumn: true
            } : null,
            vendorPayoutDetailPreviewVm: ret.data.vendorPayoutDetailPreview && !ret.data.vendorPayoutDetailPreview.unauthorized ? {
              data: ret.data.vendorPayoutDetailPreview,
              rows: ret.data.vendorPayoutDetailPreview.rows.map(r => ({ code: r[0], ignore: false, actionTitle: "", fields: r })),
              rowsFiltered: ret.data.vendorPayoutDetailPreview.rows.map(r => ({ code: r[0], ignore: false, actionTitle: "", fields: r })),
              styleTypes: [],
              styleTypesFiltered: ret.data.vendorPayoutDetailPreview.styleTypes,
              lastUpdateDateTime: formatDate(ret.data.vendorPayoutDetailPreview.lastUpdateDateTime, 'MM/dd/yyyy HH:mm:ss', 'en-US'),
              showActionColumn: false
            } : null,
            okCancelVm: FormOkCancelComponent.okCancelVm( { okText: vm.filterVm.data.reportType == 'dynamic-import-preview' ? 'Generate file for Dynamic': 'Upload to Concur' } )
          };
          var isErrorFound: boolean = false;
          if ((vm.filterVm.data.billingCycle ?? '').length != 0) {
            (vm.payoutResultPreviewVm.vendorPayoutPreviewVm.rows ?? []).forEach(r => {
              var ix = r.fields?.length - 1;
              if (r.fields[ix].length > 0) {
                r.actions.push({ code: 'ignore-error', name: 'Ignore Error' });
                isErrorFound = true;
              }
            });
            (vm.payoutResultPreviewVm.vendorPayoutPreviewVm.rowsFiltered ?? []).forEach(r => {
              var ix = r.fields?.length - 1;
              if (r.fields[ix].length > 0)
                r.actions.push({ code: 'ignore-error', name: 'Ignore Error' });
            });
          }
          if ((vm.filterVm.data.billingCycle ?? '').length == 0)
            isErrorFound = true;

          (vm.payoutResultPreviewVm.data.payoutData ?? []).forEach(r => {
            if (r.cannotIgnore && (r.comments ?? '').length > 0) {
              isErrorFound = true;
            }
          });
          vm.isReadyForProcess = !isErrorFound;
        } else if (ret.data.status == 3) {
          vm.workingText = undefined;
          vm.errorText = ret.data.errorText;
        }
      }
    } catch (err) {
      vm.errorText = err;
    } finally {
      //vm.workingText = undefined;
    }
  }

  setPayoutFormData(vm: IPayoutViewModel) {
    vm.status = undefined;
    vm.errorText = undefined;
    vm.workingText = undefined;
  }

  fileRemove(fvm: IFileLoadFormViewModel) {
    fvm.processText = undefined;
    fvm.errorText = undefined;
    fvm.fileInfo = undefined;
  }
  /**
   *
   * @param fvm
   * @param file
   */
  async fileAdd(fvm: IFileLoadFormViewModel, file: File) {

    try {
      const text = await file.text();

      if (file.type == 'application/json') {
        const data = JSON.parse(text);

        if (!data.length)
          throw new Error(`"${file.name}" must be an array of objects.`);

        fvm.processText = `Process '${file.name}' with '${data.length}' items?`;
        fvm.isInvalid = file.name.length > 0 ? true : false;

      } else if (file.type == 'text/csv') {

        fvm.isInvalid = file.name.length > 0 ? false : true;
      } else {
        fvm.isInvalid = true;
        throw new Error(`"${file.name}" Unsuported file format. Please use "CSV" file only.`);
      }

      fvm.fileInfo = {
        type: file.type,
        text: text,
        name: file.name
      };

    } catch(exc) {
      fvm.processText = undefined;
      fvm.errorText = exc;
      fvm.fileInfo = undefined;
    }

  }

  /**
   *
   * @param vm
   */
  fileFormLoadStart(vm: IPayoutViewModel) {
    const formVm: IFileLoadFormViewModel = {
      type: 'load-state',
      isInvalid: true,
      okCancelVm: FormOkCancelComponent.okCancelVm()
    }
    vm.fileLoadFormVm = formVm;
    vm.showResultForm = true;
  }

  /**
   *
   * @param vm
   */
  async fileLoadComplete(vm: IPayoutViewModel, fvm: IFileLoadFormViewModel) {
    const result = await FormOkCancelComponent.processOkAsyncReturnData(fvm.okCancelVm, 'Importing...',
      () => this.commandInvoke('concur-dynamic', {
        fileInfo: fvm.fileInfo, user: this.authService.userName()
      }));

    if (result) {
      if (result.data.status == 2 && result.data.outputType == 'file') {

        const data: Blob = new Blob([result.data.content], {
          type: result.data.contentType
        });
        saveAs(data, result.data.fileName);

        fvm.fileInfo = undefined;
        this.formFileLoadEnd(vm);
      }
      else if (result.data.status == 3) {
        fvm.errorText = result.data.errorText;
      }
    }
  }

  /**
   *
   * @param vm
   */
  formFileLoadEnd(vm: IPayoutViewModel) {
    vm.fileLoadFormVm = undefined;
    vm.showResultForm = false;
  }

  /**
   *
   * @param pvm
   * @param vm
   * @param fvm
   */
  async requestFormOk(pvm: IPageViewModel, vm: IContentViewModel, fvm: IFormViewModel) {

    const success = await FormOkCancelComponent.processOkAsync(fvm.okCancelVm, 'Saving...',
     () => this.commandInvoke('vendor-info-save', fvm.data));

    if (success)
      this.formEndRefresh(pvm);
  }

  errorFormEnd(vm: IPayoutViewModel) {
    vm.payoutResultPreviewVm = undefined
    vm.showResultForm = false;
  }
}

/**
 *
 */
interface IContentViewModel extends IPageContentViewModel {

  dataVm?: IDataViewModel;

  isValid?: boolean;
}

/**
 *
 */
interface IFilterViewModel {
  data?: IFilterData;
  fromDateInputVm?: IFormInputViewModel;
  toDateInputVm?: IFormInputViewModel;
  reportTypeVm?: IFormSelectViewModel;
  vendorTypeVm?: IFormSelectViewModel;
  billingCycleVm?: IFormSelectViewModel;
  paymentTypeVm?: IFormSelectViewModel;

  showInputRow: boolean;
}

/**
 *
 */
interface IFilterData {
  fromDate?: string;
  toDate?: string;
  reportType?: string;
  vendorType?: string[];
  options?: IOption[];
  billingCycle?: string;
  paymentMethodCode?: string;
}

/**
 *
 */
interface IDataViewModel {

  vendorInfoTabVm?: IVendorInfoViewModel;
  payoutTabVm?: IPayoutViewModel;
  dashboardTabVm?: IDashboardViewModel;

  lastDateTimeUpdated?: string;
  workingText?: string;
  errorText?: string;
}

/**
 *
 */
interface IVendorInfoViewModel {
  data?: { vendorInfo: IVendorInfoModel[] }

  vendorInfosVm: IDataPanelViewModel;

  filterVm?: IFilterViewModel;

  workingText?: string;
}


/**
 *
 */
interface IPayoutViewModel {
  filterVm?: IFilterViewModel;

  isValid?: boolean;
  isReadyForProcess?: boolean;

  status?: number;
  errorText?: string;
  workingText?: string;
  showSpinner?: boolean;
  disableSubmitButton?: boolean;
  showPaymentMethodOption?: boolean;

  showResultForm?: boolean;
  showPreviewDetailForm?: boolean;
  showDataChangeMessage: boolean;

  fileLoadFormVm?: IFileLoadFormViewModel;

  payoutResultPreviewVm?: IPayoutResultPreviewModel;

  warningMessage?: string;
}

/**
 *
 */
interface IPayoutResultPreviewModel {
  data?: { payoutData: IPayoutDatatModel[], vendorPayoutDetailPreview: IViewData; }

  vendorPayoutPreviewVm: IDataPanelViewModel;
  vendorPayoutDetailPreviewVm: IDataPanelViewModel;
  okCancelVm: IFormOkCancelViewModel;
}

/**
 *
 */
interface IDashboardViewModel {
}

/**
 *
 */
interface IFormViewModel extends IPageContentFormViewModel {
  data: IFormDataMomdel;

  vendorNumberInputVm: IFormInputViewModel;
  vendorCodeInputVm: IFormInputViewModel;
  paymentMethodCodeInputVm: IFormSelectViewModel;
  addressCodeInputVm: IFormInputViewModel;
  billingCycleInputVm: IFormSelectViewModel;
  commentsInputVm: IFormInputViewModel;

  //action: string;

  message: string;
}

/**
 *
 */
interface IFormDataMomdel {
  vendorNumber: string;
  vendorCode: string;
  paymentMethodCode: string;
  addressCode: string;
  billingCycle: string;
  comments: string;

  originalComments?: string;

  action: string;
  user: string;
}


/**
 *
 */
interface IFileLoadFormViewModel {
  type: string;

  errorText?: string;
  processText?: string;

  fileInfo?: { type: string, name: string, text: string };

  isInvalid?: boolean;

  okCancelVm: IFormOkCancelViewModel;
}

interface IVendorTypeDataModel {
  options: { label: '', value: '', icon: '', type: '' }[];
}

/**
 *
 */
interface IDataModel {
  vendorInfo: IVendorInfoModel[];
  vendorPayouts: {
    vendorTypes: IVendorTypeDataModel;
  };
}

/**
 *
 */
interface IPayoutDatatModel {
  vendorNumber: string;
  vendorName: string;
  driverNumber: string;
  type: string;
  paymentMethod: string;
  addressCode: string;
  billingCycle: string;
  baseCostAmount: string;
  payoutAmount: string;
  comments: string;
  errorIgnoreFlag: boolean;
  missedBaseRateCount: number;
  missedPayoutAmountCount: number;
  tripCount: number;
  baseCostAmountString: string;
  payoutAmountString: string;
  cannotIgnore: boolean;
}

interface IVendorInfoModel {
  vendorNumber: string;
  vendorName: string;
  type: string;
  driverNumber: string;
  paymentMethod: string;
  addressCode: string;
  billingCycle: string;
  comments: string;
  isActive: boolean;
}

interface IOutputFileInfo {
  fileName: string;
  fileContent: string;
  fileContentType: string;
}
